import PGSHelper from "../../helpers/PGSHelper.js";
import _ from "lodash";

export default class DocumentosConteo {
  constructor() {}

  static getDocData(mainData) {
    const getTable = this.getTable(mainData.data, mainData.status);

    const docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      content: [
        // Header
        {
          columns: [
            {
              width: "100%",
              alignment: "center",
              bold: true,
              text: `${mainData.TITLE}\n`,
            },
          ],
        },
        // Info Section
        {
          columns: [
            {
              width: "35%",
              alignment: "left",
              bold: true,
              text: `Creado: ${mainData.FF}\nActualizado: ${mainData.FU}\n`,
            },
            {
              width: "35%",
              alignment: "left",
              bold: true,
              text: `Departamento: ${mainData.dep}\n`,
            },
            {
              width: "30%",
              bold: true,
              text: `Generado: ${mainData.FG}\nHora Generado: ${mainData.HG}\n`,
            },
          ],
          columnGap: 10,
        },
        // Table Section
        {
          columns: [
            {
              width: "100%",
              table: {
                widths: ["*", "*", ...(mainData.status ? ["*", "*"] : [])],
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data, status) {
    // Encabezados de la tabla
    const headers = [
      {
        text: "Nombre",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      },
    ];

    // Agregar columnas adicionales dependiendo del status
    if (status) {
      headers.push(
        {
          text: "Existencia anterior",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "center",
        },
        {
          text: "Conteo",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "center",
        },
        {
          text: "Diferencia",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "center",
        }
      );
    } else {
      headers.push({
        text: "Conteo",
        border: [true, true, true, true],
        fontSize: 12,
        alignment: "center",
      });
    }

    // Construcción de la tabla
    const table = [headers];
    data.forEach((prod) => {
      const row = [{ text: prod.nm, fontSize: 12, alignment: "center" }];

      // Agregar datos adicionales dependiendo del status
      if (status) {
        row.push(
          { text: prod.ce?.ev ?? "-", fontSize: 12, alignment: "center" },
          { text: prod.cn + " "+prod.Unidad, fontSize: 12, alignment: "center" },
          { text: (prod.ce?.ei ?? "-") + " "+prod.Unidad, fontSize: 12, alignment: "center" }
        );
      } else {
        row.push({ text: prod.cn + " "+prod.Unidad, fontSize: 12, alignment: "center" });
      }

      table.push(row);
    });

    return table;
  }
}
